import { useMemo } from 'react';
import { toString } from 'lodash';

import { ServiceType, ServiceTypeLabel } from '../../EligibleServices.constants.ts';
import { Category, CategoryDto, Service, ServiceDto } from '../../EligibleServices.types.ts';

export interface Attribute {
  entityName: string;
  attributes: string[];
}


const formatData = (data: CategoryDto[]): Category[] => {
  return data?.map((item) => ({
    id: toString(item.id),
    category: item.category,
    servicesTotal: item.services?.length || 0,
    services: item.services?.map((service: ServiceDto) => ({
      id: toString(service.id),
      name: service.name,
      description: service.description,
      type: ServiceTypeLabel[service.service_type as keyof typeof ServiceType],
      serviceType: service.service_type,
    })) as Service[],
  })) as Category[];
};


const useFormatEligibleServicesData = (data?: CategoryDto[]) => {
  return useMemo(() => {
    if (data) {
      return {
        formatData: formatData(data),
        total: data.reduce((acc, item) => acc + (item.services?.length || 0), 0),
      };
    }
    return undefined;
  }, [data]);
};

export default useFormatEligibleServicesData;